import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import staff2 from '../../../../images/staff/member_1.png';



const UserEdit = ({ show, onClose, data }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    return (
        <Modal className="modal fade" show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">View User</h3>
                    </div>
                    <Button variant="" type="button" className="close px-6 py-2 text-white" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row mb-2'>
                        <div className='col-lg-4 mb-2 d-flex align-items-center justify-content-center'>
                            <LightGallery
                                onInit={onInit}
                                speed={500}
                                plugins={[lgThumbnail, lgZoom]}
                            >
                                <div data-src={data.staff_image ? data.staff_image : staff2}>
                                    <img src={data.staff_image ? data.staff_image : staff2} alt={data.staff_name} className='cursor-pointer w-150px h-150px' />
                                </div>
                            </LightGallery>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Staff Name</label>
                                <label className='text-danger font-w500 fs-6'>{data.staff_name}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Staff Mobile</label>
                                <label className='text-danger font-w500 fs-6'>{data.staff_mobile}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Staff Email</label>
                                <label className='text-danger font-w500 fs-6'>{data.staff_email}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Created Date</label>
                                <label className='text-danger font-w500 fs-6'>{data.date}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>User Name</label>
                                <label className='text-danger font-w500 fs-6'>{data.staff_username}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Staff Role</label>
                                <label className='text-danger font-w500 fs-6'>{data.role}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Branch</label>
                                <label className='text-danger font-w500 fs-6'>{data.branch}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Department</label>
                                <label className='text-danger font-w500 fs-6'>{data.department}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Created By</label>
                                <label className='text-danger font-w500 fs-6'>{data.created_by_name}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Password</label>
                                <label className='text-danger font-w500 fs-6'>{data.staff_password}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>

    );
};

export default UserEdit;
